module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-3.ae11d928.jpg";